import React, {Component} from 'react'
import '../../styles/Admin.css'
import {Tab, Tabs} from "react-bootstrap-tabs";
import ZarzadzanieStronami from "./stronyComponents/ZarzadzanieStronami";
import NowaKategoria from "./stronyComponents/NowaKategoria";
import NowaStrona from "./stronyComponents/NowaStrona";
import EdytujStrone from "./stronyComponents/EdytujStrone";
import AdminPanel from "../AdminPanel";
// import '../../styles/Tabs.css'

export default class AdminStrony extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedItem: '',
            title: '',
            itemId: '',
            selectedIndex: 0,
            category: ''
        }
    }

    render() {
        return <AdminPanel>
            <div className="componentContainer">
                <h5 style={{paddingLeft: 10}}>Strony</h5>
                <hr/>
                <Tabs selected={this.state.selectedIndex} onSelect={(index, label) => {
                    this.setState({selectedIndex: index});
                }}>
                    <Tab label={'Zarządzanie'}>
                        <ZarzadzanieStronami goEdycja={() => this.setState({selectedIndex: 4})}
                                             setItem={(item) => this.setState({title: item.tytul})}
                                             setId={(itemId) => this.setState({itemId})}/>
                    </Tab>
                    <Tab label={'Dodaj kategorię'}>
                        <NowaKategoria goZarzadzanie={() => this.setState({selectedIndex: 0})}/>
                    </Tab>
                    <Tab label={'Dodaj stronę'}>
                        <NowaStrona goZarzadzanie={() => this.setState({selectedIndex: 0})}/>
                    </Tab>
                    <Tab label={this.state.title} disabled={this.state.selectedIndex !== 4}>
                        <EdytujStrone itemId={this.state.itemId}
                                      goZarzadzanie={() => this.setState({selectedIndex: 0})}/>
                    </Tab>
                </Tabs>
            </div>
        </AdminPanel>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/AdminStrony.js